require.register("app/order/DeliveryView", function(exports, require, module){
  $0
  
});

